import React from "react"
import {Grid} from "react-bootstrap"
import idHelper from "@irati/utils/id"

import Content from "../components/NewHomePage/Content"
import TenantProducts from "../components/NewHomePage/TenantProducts"

const PlatformHomepage = () => {
  const idNamespace = idHelper("HomePage", {})

  return (
    <Grid>
      <Content />
      <TenantProducts id={idNamespace} />
    </Grid>
  )
}

export default PlatformHomepage
